///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { GtthAbstractCommand } from '../../abstract-command';
import { GtthCreateLinkCommand } from './create-link-command';
import { ActivityDTO } from '../../../../../services/project-socket/activity-dto.model';
import { GtthPreloaderModalEvent } from '../../../../../shared/preloader-modal/preloader-modal-event';
import { GtthRemoveMultipleEntitiesCommand } from '../remove-multiple-entities-command';
import { GtthLinkFeatureDtoModel } from '../../../../../services/project-socket/dto/gtth-link-feature-dto.model';
import { TopologyLinkTypeEnum } from '../../../../../services/project-socket/dto/topology-types.model';

export class GtthCreateLosesToSelectedEntitiesCommand extends GtthAbstractCommand {
    private addedLoses: GtthLinkFeatureDtoModel[];
    private addedLosesIds = [];
    private losesStationsId: number[][];

    getCommandName(): string {
        return 'GtthCreateLosesToSelectedEntitiesCommand';
    }

    doCommand(): void {
        this.historyService.eventManager.broadcast({
            name: 'togglePreloaderModal',
            eventObject: GtthPreloaderModalEvent.show('Loading')
        });

        this.addedLoses = [];

        if (!this.losesStationsId) {
            this.losesStationsId = this.historyService.logicalTopology.getAllowLosesForSelectedEntities();
        }

        this.losesStationsId.forEach((losFromTo) => {
            this.addedLoses.push(
                GtthLinkFeatureDtoModel.fromStationsIds(losFromTo[0], losFromTo[1], TopologyLinkTypeEnum.NOT_CONFIRMED_LOS)
            );
        });

        const activity = this.createActivityDTO(false);
        activity.links = [...this.addedLoses];
        this.sendActivity(activity);
    }

    undoCommand(): void {
        const removeCommand = this.historyService.command(GtthRemoveMultipleEntitiesCommand).create([], this.addedLosesIds);
        this.historyService.doCommandBypassHistory(removeCommand).then((result: boolean) => {
            this.commandResolve(result);
        });
    }

    doCommandActivity(activityDto: ActivityDTO): void {
        if (!activityDto.successful) {
            if (this.addedLoses) {
                this.historyService.notificationService.showError(activityDto?.error?.message);
            }

            this.commandEnd(activityDto.successful);
        } else {
            const commandsList = [];
            const isRedoCommand = !!this.addedLosesIds.length;
            this.addedLosesIds = [];
            activityDto.links.forEach((linkJson) => {
                const createLinkCmd = this.historyService.command(GtthCreateLinkCommand).createFromGeoJson(linkJson);
                commandsList.push(
                    this.historyService.doCommandBypassHistory(createLinkCmd, true).then(() => {
                        this.addedLosesIds.push(createLinkCmd.linkId);
                        if (this.addedLoses && !isRedoCommand) {
                            const link = this.historyService.logicalTopology.getLink(createLinkCmd.linkId);
                            this.historyService.logicalTopology.addSelectedLink(link);
                        }
                    })
                );
            });

            Promise.all(commandsList).then((_res) => {
                this.commandEnd(activityDto.successful);
            });
        }
    }

    isDisabledInReadOnlyMode(): boolean {
        return true;
    }

    isModifyTopology(): boolean {
        return true;
    }

    isClearDesign(): boolean {
        return true;
    }

    private commandEnd(isSuccessful: boolean) {
        this.historyService.eventManager.broadcast({
            name: 'togglePreloaderModal',
            eventObject: GtthPreloaderModalEvent.hide()
        });

        if (this.commandResolve) {
            this.commandResolve(isSuccessful);
        }
    }
}
